import { z } from 'zod'

// Response schema for the trial days endpoint
export const TrialDaysResponseSchema = z.object({
  display_trial_days: z.number(),
  actual_trial_days: z.number(),
})

export type TrialDaysResponse = z.infer<typeof TrialDaysResponseSchema>
